const actionTypes = require('../loansConstants/actionTypes');
const { APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
const { API_CENTER, DATE_FORMAT_API } = require('constants/index');
const moment = require('moment');

const loanRepaymentPlanRequest = () => ({
    type: actionTypes.LOAN_REPAYMENT_PLAN_REQUEST
});

const loanRepaymentPlanSuccess = (currency, data, loanType) => ({
    type: actionTypes.LOAN_REPAYMENT_PLAN_SUCCESS,
    payload: {
        currency,
        list: get(data, 'listaAmortPrestamo.amortPrestamo', []) || [],
        nextPage: get(data, '_links.nextPage.href', ''),
        loanType
    }
});

const loanRepaymentPlanFailure = (error, loanType) => ({
    type: actionTypes.LOAN_REPAYMENT_PLAN_FAILURE,
    payload: {
        error,
        loanType
    }
});

const repaymentPlanReset = () => ({
    type: actionTypes.LOAN_REPAYMENT_PLAN_RESET
});

const nextPageRequest = () => ({
    type: actionTypes.LOAN_REPAYMENT_PLAN_NEXT_PAGE_REQUEST
});

const nextPageSuccess = (currency, data) => ({
    type: actionTypes.LOAN_REPAYMENT_PLAN_NEXT_PAGE_SUCCESS,
    payload: {
        currency,
        list: get(data, 'listaAmortPrestamo.amortPrestamo', []) || [],
        nextPage: get(data, '_links.nextPage.href', '')
    }
});

const requestNextPage = loanId => (dispatch, getState) => {
    const immLoan = getState().loans.getIn(['byId', loanId]);
    const nextPageURL = getState().loanRepaymentPlan.get('nextPage');
    const currency = immLoan.getIn(['balance', 'currency']);

    dispatch(nextPageRequest());
    return APIGet(dispatch, nextPageURL)
        .then(response => dispatch(nextPageSuccess(currency, response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(loanRepaymentPlanFailure(response.error.description));
            } else {
                throw response;
            }
        });
};

const fetchRepaymentPlan = loanId => (dispatch, getState) => {
    const immLoan = getState().loans.getIn(['byId', loanId]);
    const immLoanRepaymentPlan = getState().loanRepaymentPlan;
    const loanType = immLoan.get('type');

    const currency = immLoan.getIn(['balance', 'currency']);
    const fromDate =
        immLoanRepaymentPlan.getIn(['filters', 'date', 'from']) || moment().startOf('day');
    const toDate =
        immLoanRepaymentPlan.getIn(['filters', 'date', 'to']) ||
        moment('9999-01-01').startOf('day');

    const params = {
        query: {
            codMonedaPrestamo: currency,
            producto: immLoan.get('newProduct'),
            numeroContrato: immLoan.get('newContractNumber'),
            empresa: API_CENTER,
            operacion: 'A',
            fechaDesde: fromDate.format(DATE_FORMAT_API),
            fechaHasta: toDate.format(DATE_FORMAT_API)
        }
    };

    dispatch(loanRepaymentPlanRequest());

    return APIGet({ dispatch, endpoint: 'loanRepaymentPlan', params })
        .then(response => dispatch(loanRepaymentPlanSuccess(currency, response, loanType)))
        .catch(response => {
            if (!!response.error) {
                dispatch(loanRepaymentPlanFailure(response.error.description, loanType));
            } else {
                throw response;
            }
        });
};

const clearLoanRepaymentPlanFilters = loanId => dispatch => {
    dispatch({
        type: actionTypes.LOAN_REPAYMENT_PLAN_CLEAR_FILTERS
    });
    dispatch(fetchRepaymentPlan(loanId));
};

const setLoanRepaymentPlanFilters = (filters, loanId) => dispatch => {
    dispatch({
        type: actionTypes.LOAN_REPAYMENT_PLAN_SET_FILTERS,
        payload: {
            filters
        }
    });
    dispatch(fetchRepaymentPlan(loanId));
};

module.exports = {
    fetchRepaymentPlan,
    repaymentPlanReset,
    clearLoanRepaymentPlanFilters,
    setLoanRepaymentPlanFilters,
    requestNextPage
};
